Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var RepackCorePlugin = ()=>({
        name: 'repack-core-plugin',
        loadEntry: (param)=>{
            var remoteInfo = param.remoteInfo;
            return _async_to_generator._(function*() {
                var client = require('../ScriptManager/index.js');
                var ScriptManager = client.ScriptManager, getWebpackContext = client.getWebpackContext;
                var entry = remoteInfo.entry, entryGlobalName = remoteInfo.entryGlobalName;
                try {
                    yield ScriptManager.shared.loadScript(entryGlobalName, undefined, getWebpackContext(), entry);
                    // @ts-ignore
                    if (!globalThis[entryGlobalName]) {
                        throw new Error();
                    }
                    // @ts-ignore
                    return globalThis[entryGlobalName];
                } catch  {
                    console.error(`Failed to load remote entry: ${entryGlobalName}`);
                }
            })();
        },
        generatePreloadAssets: ()=>_async_to_generator._(function*() {
                // noop for compatibility
                return Promise.resolve({
                    cssAssets: [],
                    jsAssetsWithoutEntry: [],
                    entryAssets: []
                });
            })()
    });
var _default = RepackCorePlugin;
